import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=6fed983a&lang=pug&"
import script from "./Instagram.vue?vue&type=script&lang=js&"
export * from "./Instagram.vue?vue&type=script&lang=js&"
import style0 from "./Instagram.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fed983a')) {
      api.createRecord('6fed983a', component.options)
    } else {
      api.reload('6fed983a', component.options)
    }
    module.hot.accept("./Instagram.vue?vue&type=template&id=6fed983a&lang=pug&", function () {
      api.rerender('6fed983a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/Instagram.vue"
export default component.exports